import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { VirtualActivityList } from "@/components/activity-list";
import { EmptyState, PageHeader } from "@/components/page";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useDevices, useVault } from "@/lib/hooks";

export const Route = createFileRoute("/_app/activity")({ component: ActivityPage });

const ALL = "__all";

function ActivityPage() {
  const v = useVault();
  const devices = useDevices();
  const [device, setDevice] = useState<string>(ALL);
  const [project, setProject] = useState<string>(ALL);
  const fileToProject = new Map((v.snapshot?.files ?? []).map((f) => [f.id, f.project_id]));
  const items = v.activity.filter((it) => {
    if (device !== ALL && it.op.hlc.device_id !== device) return false;
    if (project !== ALL) {
      const pid =
        "project_id" in it.op ? it.op.project_id : "file_id" in it.op ? fileToProject.get(it.op.file_id) : undefined;
      if (pid !== project) return false;
    }
    return true;
  });
  const deviceItems = [
    { label: "All devices", value: ALL },
    ...(devices.data ?? []).map((d) => ({ label: d.name, value: d.id })),
  ];
  const projectItems = [
    { label: "All projects", value: ALL },
    ...(v.snapshot?.projects ?? []).map((p) => ({ label: p.name, value: p.id })),
  ];
  return (
    <>
      <PageHeader
        title="Activity"
        description="Every change in the vault, decrypted here. Newest first."
        actions={
          <>
            <Select value={device} onValueChange={(val) => setDevice(val ?? ALL)} items={deviceItems}>
              <SelectTrigger className="w-44">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {deviceItems.map((i) => (
                  <SelectItem key={i.value} value={i.value}>
                    {i.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Select value={project} onValueChange={(val) => setProject(val ?? ALL)} items={projectItems}>
              <SelectTrigger className="w-44">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {projectItems.map((i) => (
                  <SelectItem key={i.value} value={i.value}>
                    {i.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </>
        }
      />
      {items.length === 0 ? <EmptyState title="No activity matches" /> : <VirtualActivityList items={items} />}
    </>
  );
}
